import styled from "styled-components";

export const AppContainer = styled.div`
  flex: 1;
  width: 100%;
  max-width: 100vw;
  padding-right: 24px;
  padding-left: 24px;
  background-color: transparent;

  @media (max-width: 640px) {
    padding-right: 14px;
    padding-left: 14px;
  }
`;

export const PageContainer = styled.div`
  width: 100%;
  max-width: 760px;
  margin: 0 auto;
  padding-top: 40px;
  padding-bottom: 48px;
  display: flex;
  flex-direction: column;
  align-items: stretch;

  @media (max-width: 640px) {
    padding-top: 22px;
    padding-bottom: 28px;
  }
`;

export const Margin = styled.div`
  margin-top: 20px;
  margin-bottom: 20px;
`;

export const MarginSmall = styled.div`
  margin-top: 10px;
  margin-bottom: 10px;
`;

export const Heading1 = styled.h1`
  font-family: var(--cl-font-serif);
  font-weight: 500;
  font-size: 40px;
  line-height: 1.15;
  color: var(--cl-text);
  letter-spacing: -0.02em;
  -webkit-font-smoothing: antialiased;
  text-align: center;
  padding: 0;
  margin: 0;

  @media (max-width: 640px) {
    font-size: 30px;
  }
`;

export const Heading4 = styled.h4`
  font-family: var(--cl-font-sans);
  font-weight: 600;
  font-size: 20px;
  color: var(--cl-text);
  -webkit-font-smoothing: antialiased;
  text-align: left;
  padding: 0;
  margin: 0;
  line-height: 1.3;
  letter-spacing: -0.01em;
`;

export const Paragraph = styled.p`
  font-weight: 400;
  font-size: 14px;
  font-family: var(--cl-font-sans);
  color: ${(props: any) => (props.light ? "var(--cl-text)" : "var(--cl-text-muted)")};
  -webkit-font-smoothing: antialiased;
  text-align: left;
  padding: 0;
  margin: 0;
  line-height: 1.65;
`;

export const Small = styled.p`
  font-weight: 400;
  font-size: 12px;
  font-family: var(--cl-font-sans);
  color: ${(props: any) => (props.light ? "var(--cl-text)" : "var(--cl-text-faint)")};
  -webkit-font-smoothing: antialiased;
  text-align: center;
  padding: 0;
  margin: 0;
  line-height: 1.4;
`;

export const ErrorIndicator = styled(Small)`
  color: var(--cl-danger);
  font-weight: 500;
  margin-top: 12px;
  text-align: left;
`;
